import React from "react";
import { Chip, Typography } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
const StyledTypography = styled(Typography.CaptionText).attrs()`
  display: inline-block;
  text-transform: ${(props) => (props.lowercase ? "lowercase" : "capitalize")};
  margin-bottom: 0;
`;
const CategoryTab = ({
  title,
  categories,
  selectedCategory,
  setSelectedCategory,
  setSelectedFilterIndex,
}) => {
  return (
    <div className="d-flex align-items-center">
      <Typography.LabelText className="mr-12" color="dark" shade="c200">
        Showing for {title === "xoxo reward link" ? "type" : "status"}
      </Typography.LabelText>
      {categories.map((category, index) => (
        <Chip
          key={index}
          color={selectedCategory === index ? "custom" : "base"}
          backgroundColor="primary"
          backgroundShade="c05"
          textColor="primary"
          textShade="c03"
          label={
            <StyledTypography
              color={selectedCategory === index ? "primary" : "base"}
              shade={selectedCategory === index ? "c03" : "c200"}
              id={`reports-${category.title}`}
            >
              {category.title}
            </StyledTypography>
          }
          style={{
            height: "24px",
          }}
          onClick={() => {
            setSelectedCategory(index);
            setSelectedFilterIndex(-1);
          }}
          className="mr-12"
          radius={8}
          variant="fill"
        />
      ))}
    </div>
  );
};

export default CategoryTab;
